import { createId as cuid2 } from '@paralleldrive/cuid2';

export const createId = () => {
  return cuid2();
};

export const createPlayerPersistentId = () => {
  return `player_${cuid2()}`;
};

export const createPlayerPeerId = () => {
  return `player-peer_${cuid2()}`;
};

export const createPlayerCallbackKey = () => {
  return `player-callback_${cuid2()}`;
};

export const createMessageCaptureHostId = () => {
  return `host_${cuid2().substring(0, 4)}`;
};

// Peer ids cannot contain symbols other than dash and underscore
export const createRemoteControlClientId = () => {
  return `rc-client_${cuid2()}`;
};

export const createRemoteHostId = () => {
  return `rc-host_${cuid2()}`;
};

export const createHostId = () => {
  return `host_${cuid2()}`;
};
